// The HTTP layer has to know a 401 belongs to a Firebase session without
// importing the auth store (that import is a cycle).

let active = false;

export function setFirebaseSession(on: boolean): void {
  active = on;
}

export function firebaseSessionActive(): boolean {
  return active;
}
